module.exports = "//img1.rrcimg.com/_next/static/src/assets/wf_2TB1e.png";